import * as React from "react";
import { Dropdown, Option, Field } from "@fluentui/react-components";
import { GlpiUser } from "../types/glpi";
import { formatUser } from "../hooks/useTechnicians";

interface Props {
  technicians: GlpiUser[];
  loading: boolean;
  value: number | null;
  onChange: (id: number | null) => void;
  label?: string;
  required?: boolean;
}

export function TechnicianDropdown({
  technicians,
  loading,
  value,
  onChange,
  label = "Technicien assigné",
  required,
}: Props): React.ReactElement {
  const valueText = React.useMemo(() => {
    const t = technicians.find((x) => x.id === value);
    return t ? formatUser(t) : "";
  }, [technicians, value]);

  return (
    <Field label={label} required={required}>
      <Dropdown
        placeholder={loading ? "Chargement…" : "Aucun"}
        value={valueText}
        selectedOptions={value !== null ? [String(value)] : []}
        onOptionSelect={(_, data) => {
          const v = data.optionValue ? Number(data.optionValue) : null;
          onChange(v);
        }}
        disabled={loading}
      >
        <Option value="" text="(aucun)">
          (aucun)
        </Option>
        {loading && (
          <Option value="__loading" text="Chargement..." disabled>
            Chargement&hellip;
          </Option>
        )}
        {technicians.map((t) => (
          <Option key={t.id} value={String(t.id)} text={formatUser(t)}>
            {formatUser(t)}
          </Option>
        ))}
      </Dropdown>
    </Field>
  );
}
